export function handleAccordionHeadClick(e) {
  const $accordionHead = $(e.currentTarget);

  $accordionHead.siblings('.accordion__body').toggleClass('d-none');
  $($accordionHead.children('.accordion__icon')[0].children[0]).toggleClass('accordion-reverse');
}
